import { QueryV1GetSubscription, QueryV2GetSubscription } from '@/modules/api';

import api from '../api';

export function apiV2GetSubscription() {
  return api.get<QueryV2GetSubscription | null>('v2', '/subscription');
}
apiV2GetSubscription.requestKey = 'v2-get-subscription';

export function apiV1GetSubscription() {
  return api.get<QueryV1GetSubscription | null>('v1', '/subscription');
}
apiV1GetSubscription.requestKey = 'v1-get-subscription';
